import './SavedPaymentForm.css';
import React, { useEffect, useState, useMemo, useRef, forwardRef, useImperativeHandle } from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { PurchaseConfirmation } from 'Features/Payment/PurchaseConfirmation';
import { getTaxByZip } from 'State/Checkout';
import { CardInfo } from 'Components/CardInfo';
import { useForm } from 'Hooks/useForm';

export const SavedPaymentForm = forwardRef(
  (
    {
      onFormSubmit,
      submitButtonText = 'Submit',
      formName = 'savedPaymentForm',
      onEditCard,
      paymentMethod,
      selectedPlan,
      billingAddress = {},
      setVtCheckMissing,
      setEnablePaymentButton,
    },
    ref
  ) => {
    const { state = '' } = billingAddress;
    const [isPurchaseConfirmed, setPurchaseConfirmation] = useState(false);
    const savedCardForm = useRef();
    const showPurchaseConfirm = useMemo(
      () => state === 'VERMONT' && selectedPlan.period === 'NoOfYears',
      [state, selectedPlan]
    );

    // Ref Object giving PaymentPage component access to form submission
    const formSubmitRef = {
      submitForm: () => {
        savedCardForm.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      },
    };

    const { formError, handleSubmit } = useForm({
      onFormSubmit,
      formName,
      alwaysAllowSubmit: true,
    });

    useEffect(() => {
      if (paymentMethod && paymentMethod.billingAddress && paymentMethod.billingAddress.zipCode) {
        getTaxByZip(paymentMethod.billingAddress.zipCode);
      }
    }, [paymentMethod]);

    useEffect(() => {
      const billingAddressLoaded = Object.keys(billingAddress).length > 0;
      setVtCheckMissing(!billingAddressLoaded || (showPurchaseConfirm && !isPurchaseConfirmed));
      if (showPurchaseConfirm) {
        setEnablePaymentButton(isPurchaseConfirmed);
      } else {
        setPurchaseConfirmation(false);
        setEnablePaymentButton(billingAddressLoaded);
      }
    }, [billingAddress, showPurchaseConfirm, isPurchaseConfirmed, setVtCheckMissing, setEnablePaymentButton]);

    useImperativeHandle(ref, () => formSubmitRef);

    return (
      <form ref={savedCardForm} className="savedPaymentForm" onSubmit={(event) => handleSubmit(event)} name={formName}>
        <div className="sectionFlex savedPaymentCard">
          <CardInfo cardNumber={paymentMethod.cardNumber} cardType={paymentMethod.cardType} />
          <button className="updateCardButton" onClick={onEditCard}>
            Update Card
          </button>
        </div>
        <PurchaseConfirmation
          show={showPurchaseConfirm}
          ctaText={submitButtonText}
          selectedPlan={selectedPlan}
          handleChange={setPurchaseConfirmation}
        />
        <SubmitError error={formError} formName={formName} />
      </form>
    );
  }
);
